import React from 'react';
import { Link } from 'react-router-dom';
// import React, { lazy, Suspense } from 'react';
import './SFP.css';
import LogisticsPageHero from '../Logistics/LogisticsPageHero';
// import WhyChoosePPP from './WhyChoosePPP';
import SFPCards from './SFPCards';
import SFPBenefits from './SFPBenefits';
import SFPInfo from './SFPInfo';
import WhyPartner from './WhyPartner';
// import SuccessStories from './SuccessStories';
import SFPFaq from './SFPFaq';
import Newsletter from '../Homepage/Newsletter';
import Footer from '../Layouts/Footer';
import Canonical from '../../seo/Canonical';
import ComparisonTable from '../Common/ComparisonTable';
import SfpAeoBlock from './SfpAeoBlock';
import SfpDirectAnswers from './SfpDirectAnswers';
import { Helmet } from 'react-helmet-async';
import RelatedLinks from '../Common/RelatedLinks';

const SFP: React.FC = () => {
  return (
    <div className="sfp-page logistics-page">
      <Canonical baseUrl="https://www.pickpackpro.co.uk" />
      
      <Helmet>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Article",
              "headline": "Seller Fulfilled Prime Services UK for Amazon Sellers",
              "description": "Our Seller Fulfilled Prime services help Amazon sellers achieve and maintain Prime eligibility without relying solely on FBA.",
              "author": {
                "@type": "Organization",
                "name": "Pick Pack Pro",
                "url": "https://www.pickpackpro.co.uk/"
              },
              "publisher": {
                "@type": "Organization",
                "name": "Pick Pack Pro",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://www.pickpackpro.co.uk/Images/ppp-orange-Blue-logo.webp"
                }
              },
              "datePublished": "2024-01-10T08:00:00+00:00",
              "dateModified": "${new Date().toISOString()}",
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "https://www.pickpackpro.co.uk/seller-fulfilled-prime-services"
              }
            }
          `}
        </script>
      </Helmet>

      <LogisticsPageHero
        ariaLabel="Seller Fulfilled Prime UK"
        imageSrc="/Images/SFP.webp"
        imageAlt="Seller Fulfilled Prime fulfilment"
        titleLight="Seller Fulfilled Prime Services UK "
        titleAccent="for Amazon Sellers"
        description={
          <>
            <p>
              Our Seller Fulfilled Prime services help Amazon sellers achieve and maintain Prime eligibility
              without relying solely on FBA. We provide fast, accurate order fulfilment from our{' '}
              <Link to="/our-fulfilment-center">UK fulfilment centre</Link>, helping you meet Amazon&apos;s{' '}
              <Link to="/blog/seller-fulfilled-prime-uk-requirements-expert-guide">
                Seller Fulfilled Prime UK requirements
              </Link>{' '}
              while retaining inventory control — compare options in our{' '}
              <Link to="/blog/sfp-vs-fba-2026">SFP vs FBA 2026 guide</Link> and{' '}
              <Link to="/blog/seller-fulfilled-prime-guide-uk-sellers">Seller Fulfilled Prime guide for UK sellers</Link>.
            </p>
          </>
        }
        primaryCta={{ label: 'Get a Quote', to: '/contact-fulfillment-services' }}
      />

      <SfpAeoBlock />

      <ComparisonTable
        title="Seller Fulfilled Prime UK vs Amazon FBA: Which Is Right for Your Business?"
        leftLabel="Pick Pack Pro Seller Fulfilled Prime UK"
        rightLabel="Amazon FBA"
        rows={[
          { feature: 'Fulfilment Costs', pickPackPro: 'Transparent 3PL pick, pack, storage, and dispatch pricing', alternative: 'Variable FBA fulfilment and storage fees' },
          { feature: 'Prime Badge', pickPackPro: 'Maintain Prime eligibility through Seller Fulfilled Prime (SFP)', alternative: 'Prime eligibility through Amazon FBA' },
          { feature: 'Inventory Control', pickPackPro: 'Stock stored in your dedicated UK fulfilment warehouse with full visibility', alternative: 'Inventory stored within Amazon fulfilment centres' },
          { feature: 'Brand Experience', pickPackPro: 'Branded packaging, inserts, and customised fulfilment options', alternative: 'Standard Amazon packaging and fulfilment processes' },
          { feature: 'Order Fulfilment', pickPackPro: 'Fast, SLA-driven dispatch designed to meet Amazon SFP requirements', alternative: 'Amazon manages fulfilment and customer delivery' },
          { feature: 'Multi-Channel Selling', pickPackPro: 'One inventory for Amazon, Shopify, TikTok Shop, eBay, and more', alternative: 'Primarily designed for Amazon orders' },
          { feature: 'Business Flexibility', pickPackPro: 'Greater control over operations, inventory, and fulfilment strategy', alternative: 'Less operational control but simplified fulfilment' }
        ]}
      />

      {/* Why Choose Pick Pack Pro Section */}
      {/* <WhyChoosePPP /> */}

      {/* SFP Cards Section */}
      <SfpDirectAnswers />

      <SFPCards />

      {/* Key Benefits Section */}
      <SFPBenefits />

      {/* Seller Fulfilled Prime Info Section */}
      <SFPInfo />

      {/* Why Partner Section */}
      <WhyPartner />

      {/* Success Stories Section */}
      {/* <SuccessStories /> */}

      {/* FAQs Section */}
      <SFPFaq />

      <RelatedLinks
        serviceLinks={[
          { to: '/amazon-fba-prep-services', label: 'Amazon FBA prep services' },
          { to: '/multi-channel-fulfillment-services', label: 'Multi-channel fulfilment services' }
        ]}
        blogLink={{ to: '/blog/sfp-vs-fba-2026', label: 'SFP vs FBA in 2026 (full comparison)' }}
      />

      <Newsletter />
      <Footer />
    </div>
  );
};

export default SFP;
